import type { AbapLintRuleMeta } from '@/abap/types';
import type {
  TLAIFixTemplate,
  TLAIIssueFixResponse,
  TLAIRemedyV3FindingResponse,
  TLAIRemedyV3ObjectDetail,
  TLAIRemedyV3Priority,
  TLAIRemedyV3ScanInfo,
} from '@/types/api';

export enum CodeRemedyLibraryTab {
  REMEDIES = 'Projects',
  LIBRARY = 'Library',
  RULES = 'AI Instructions',
}

export enum CodeRemedyFixLibraryTab {
  ABAP = 'abap',
  FLE = 'fle',
  TEMPLATES = 'templates',
}

export enum RemedyObjectActionTab {
  FIXES = 'Fixes',
  SYNTAX_ISSUES = 'Syntax',
  SCANS = 'Findings',
}

export enum CodeRemedyObjectTab {
  ALL = 'All',
  ASSIGNED_TO_ME = 'Assigned to Me',
  READY_FOR_REVIEW = 'Awaiting Review',
}

export enum FixTemplateTargetFilterField {
  NOTE = 'NOTE',
  CHECK_TITLE = 'CHECKTITLE',
  CHECK_MESSAGE = 'CHECKMSG',
  REFERENCE_OBJECT = 'REF OBJECT',
  CUSTOM_FIELD = 'CUSTOM',
}

export type ScanObjectMap = Record<TLAIRemedyV3ObjectDetail['object_id'], TLAIRemedyV3ScanInfo[]>;

export type IssueFixMap = Record<TLAIRemedyV3FindingResponse['finding_id'], TLAIFixTemplate['fix_template_id']>;

export type RecommendedFixesMap = Record<TLAIRemedyV3FindingResponse['finding_id'], TLAIIssueFixResponse[]>;

export type IssuesGroupedByPriority = Record<TLAIRemedyV3Priority, TLAIRemedyV3FindingResponse[]>;

export type ActionIssueResult = {
  type: 'syntax' | 'export';
  object_id: TLAIRemedyV3ObjectDetail['object_id'];
  message: string;
  line?: number;
  word?: string | null;
};

export enum RemedyObjectType {
  PROGRAM = 'PROG',
  CLASS = 'CLAS',
  FUNCTION_GROUP = 'FUGR',
}

export enum RemedyObjectAccess {
  READ_WRITE = 'READ_WRITE',
  UNMODIFIABLE_TYPE = 'UNMODIFIABLE_TYPE',
  UNMODIFIABLE_STATUS = 'UNMODIFIABLE_STATUS',
  UNKNOWN_USER = 'UNKNOWN_USER',
  NOT_ASSIGNED = 'NOT_ASSIGNED',
}

export enum RemedyFixType {
  STATIC = 'STATIC',
  FLE = 'FLE',
}

export type RemedyFix = {
  type: RemedyFixType;
  id: string;
  display_name?: string;
  description: string;
  tags?: string[];
  metadata?: Partial<AbapLintRuleMeta>;
};

export enum ObjectRemedyPageTab {
  AGENTIC = 'Agentic',
  EDITOR = 'Editor',
}
